module.exports = __webpack_public_path__ + "static/img/news_tu2.9e33d9a.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/news_tu2.png
// module id = 9ZSB
// module chunks = 0